/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-shadow */
export enum ImageVariantEnum {
  Thumbnail = 'Thumbnail',
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large',
  XLarge = 'XLarge',
}
